import { queryOptions } from '@tanstack/react-query';
import { PosService } from '@/features/pos/services/PosService.ts';

export const posQueryKeys = {
  all: ['pos'],
  list: () => [...posQueryKeys.all, 'list'],
};

export const posQueries = {
  list: () =>
    queryOptions({
      queryKey: posQueryKeys.list(),
      queryFn: PosService.list,
    }),
};
